import React from 'react';

const UpgradePlanForm = () => {
    return (
        <div className={"text-center form-colour"}>
            <iframe className={"rounded col-10 google-form"}
                src="https://docs.google.com/forms/d/e/1FAIpQLScZ7DZ0sdscmFCCLnOjJ1Er71416Yvc4CBuJGB1F6SweZ-GIg/viewform?usp=sf_link"
                title="External Page" 
            ></iframe>
        </div>
    );
};

export default UpgradePlanForm;